import React from 'react';
import cx from 'classnames';

import ArrowR from '@svg/arrow-r.svg';
import ArrowL from '@svg/arrow-l.svg';

export const ArrowButton = ({
  className,
  children,
  reversed = false,
  isSmall = false,
  ...props
}) => {
  return (
    <button
      className={cx(
        className,
        'flex gap-x-3 items-center font-medium text-xl ',
        {
          'flex-row-reverse': reversed,
          'md:text-3xl': !isSmall,
        },
      )}
      {...props}>
      {children}
      {reversed ? (
        <ArrowL className='w-10 fill-current' />
      ) : (
        <ArrowR className='w-10 fill-current' />
      )}
    </button>
  );
};
export const ArrowButtonDiv = ({
  className,
  children,
  reversed = false,
  ...props
}) => {
  return (
    <div
      className={cx(
        className,
        'flex gap-x-3 items-center text-xl md:text-3xl  font-medium cursor-pointer',
        {
          'flex-row-reverse': reversed,
        },
      )}
      {...props}>
      {children}
      {reversed ? <ArrowL className='w-10' /> : <ArrowR className='w-10' />}
    </div>
  );
};
